import React from "react";
import "../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "react-bootstrap";

function Footer() {
  //let date = new Date();
  //let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <br/>
          <h6 style={{color:"#21b480"}}>Designed and Developed by Nishat Ahmed </h6>
          <h6 className="text-light">Location: Mohakhali,Dhaka,Bangladesh</h6>
        </Col>
        <Col md="4" className="footer-copywright mt-5">
        <span className="text-light">Copyright {(new Date()).getFullYear()} All Rights Reserved @ Nishat Ahmed</span>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
          <li>
              <p style={{color:"#21b480"}}>Email:nishatahmed4485@gmail.com</p>
            </li>
            <li className="social-icons">
              <a
                href="https://github.com/nishat-1998"
                style={{ color: "white" }}
              >
                <i className="fab fa-github"></i>
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://twitter.com/DewanNishatAhm1"
                style={{ color: "white" }}
              >
                <i className="fab fa-twitter"></i>
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/leo-dewan-nishat-ahmed-252a0a184/"
                style={{ color: "white" }}
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/nishat.ahmed.940/"
                style={{ color: "white" }}
              >
                <i className="fab fa-instagram"></i>
              </a>
            </li>
           
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
